export default ({ backInStock: { variantIds } }, variantId) =>
  variantIds.includes(variantId);
